export const CREATE_LEAVE_TYPE_MUTATION = `
  mutation CreateLeaveType($object: leave_types_insert_input!) {
    insert_leave_types_one(object: $object) {
      id
      leave_type_name
      leave_type_description
      leave_type_status
      leave_type_days
      leave_type_hours
      leave_type_deduct_from_annual_leave
      company_id
      created_at
    }
  }
`;

export const UPDATE_LEAVE_TYPE_MUTATION = `
  mutation UpdateLeaveType($id: Int!, $set: leave_types_set_input!) {
    update_leave_types_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      leave_type_name
      leave_type_description
      leave_type_status
      leave_type_days
      leave_type_hours
      leave_type_deduct_from_annual_leave
      company_id
      created_at
    }
  } 
`;

export const DELETE_LEAVE_TYPE_MUTATION = `
  mutation DeleteLeaveType($id: Int!) {
    delete_leave_types_by_pk(id: $id) {
      id
      leave_type_name
    }
  }
`;
